// extracted by mini-css-extract-plugin
export default {"overridesFooter":"Footer-module--overrides--Footer--HMgt2","overridesFooterNav":"Footer-module--overrides--FooterNav--DtvdH"};